import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cd5f926&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd5f926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd5f926')) {
      api.createRecord('2cd5f926', component.options)
    } else {
      api.reload('2cd5f926', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cd5f926&scoped=true", function () {
      api.rerender('2cd5f926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/approveAnnual/index.vue"
export default component.exports